import { useRef } from "react";
import PropTypes from "prop-types";
import ChatReactionBar from "./ChatReactionBar";
import ChatReactionButton from "./ChatReactionButton";
import ChatReactionPicker from "./ChatReactionPicker";
import ChatReplyActionButton from "../chatReply/ChatReplyActionButton";
import { getMyReactionEmoji } from "./chatReactionUtils";
import "./chatReactions.scss";

const ChatBubbleActions = ({
  message,
  currentUserId,
  allowedEmojis = [],
  pickerOpen = false,
  onTogglePicker,
  onReact,
  onReply,
}) => {
  const anchorRef = useRef(null);

  if (!message?._id) return null;

  return (
    <div
      ref={anchorRef}
      className={`chat-bubble-actions${pickerOpen ? " is-open" : ""}`}
    >
      {pickerOpen && allowedEmojis.length > 0 && (
        <ChatReactionPicker
          emojis={allowedEmojis}
          selected={getMyReactionEmoji(message.reactions, currentUserId)}
          onPick={(emoji) => onReact?.(message, emoji)}
          anchorRef={anchorRef}
        />
      )}
      <ChatReactionBar
        reactions={message.reactions}
        currentUserId={currentUserId}
      />
      <div className="chat-reply-actions">
        {allowedEmojis.length > 0 && (
          <ChatReactionButton
            active={pickerOpen}
            onClick={() => onTogglePicker?.(message._id)}
          />
        )}
        <ChatReplyActionButton onClick={() => onReply?.(message)} />
      </div>
    </div>
  );
};

ChatBubbleActions.propTypes = {
  message: PropTypes.object,
  currentUserId: PropTypes.string,
  allowedEmojis: PropTypes.arrayOf(PropTypes.string),
  pickerOpen: PropTypes.bool,
  onTogglePicker: PropTypes.func,
  onReact: PropTypes.func,
  onReply: PropTypes.func,
};

export default ChatBubbleActions;
